module.exports = __webpack_public_path__ + "static/media/download.24549267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download.png
// module id = 414
// module chunks = 0